import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import FeatureHighlights from './components/FeatureHighlights';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/homepage');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-8 md:py-12">
        <div className="w-full max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="order-2 lg:order-1 space-y-6">
              <div className="text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
                  <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg flex-shrink-0">
                    <Icon
                      name="HardHat"
                      size={28}
                      color="var(--color-primary)"
                      strokeWidth={2}
                    />
                  </div>

                  <h1 className="text-2xl md:text-3xl font-bold text-foreground">
                    RenovationFlow
                  </h1>
                </div>

                <p className="text-base text-muted-foreground">
                  Professional construction project management made simple
                </p>
              </div>

              <div className="hidden lg:block">
                <FeatureHighlights />
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="w-full max-w-md mx-auto bg-card rounded-2xl shadow-elevated border border-border p-6 md:p-8 overflow-hidden">
                <div className="mb-6">
                  <h2 className="text-2xl font-bold text-foreground mb-2">
                    Welcome Back
                  </h2>

                  <p className="text-sm text-muted-foreground">
                    Sign in to manage your renovation projects
                  </p>
                </div>

                <LoginForm />

                <div className="mt-8 pt-6 border-t border-border overflow-hidden">
                  <div className="w-full max-w-full">
                    <TrustSignals />
                  </div>
                </div>
              </div>
            </div>

            <div className="order-3 lg:hidden">
              <FeatureHighlights />
            </div>
          </div>
        </div>
      </div>

      <footer className="py-6 px-4 border-t border-border bg-card">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              &copy; {new Date()?.getFullYear()} RenovationFlow. All rights reserved.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <button className="text-sm text-muted-foreground hover:text-foreground transition-smooth">
                Privacy Policy
              </button>

              <button className="text-sm text-muted-foreground hover:text-foreground transition-smooth">
                Terms of Service
              </button>

              <button className="text-sm text-muted-foreground hover:text-foreground transition-smooth">
                Support
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;